import i18n, { i18n_t } from '@/locales/i18n';
const NodeErrorCodeMap: Record<string, string> = {
  EACCES: i18n_t('权限被拒绝'),
  EADDRINUSE: i18n_t('地址已在使用'),
  ECONNREFUSED: i18n_t('网络异常，连接被拒绝'),
  ECONNRESET: i18n_t('网络异常，连接被关闭'),
  ECONNABORTED: i18n_t('网络异常，连接被中止'),
  EEXIST: i18n_t('文件存在'),
  EISDIR: i18n_t('路径是一个目录'),
  EMFILE: i18n_t('已达到系统允许的最大文件描述符数 '),
  ENOENT: i18n_t('文件/文件夹不存在'),
  ENOTDIR: i18n_t('路径不是目录'),
  ENOTEMPTY: i18n_t('目录不为空'),
  ENOTFOUND: i18n_t('网络异常，DNS查找失败'),
  EPERM: i18n_t('权限不足，不允许操作'),
  EPIPE: i18n_t('PIPE关闭'),
  ETIMEDOUT: i18n_t('网络异常，操作超时'),
  EPROTO: i18n_t('网络不稳定，请求协议出错'),
  ERR_NETWORK: i18n_t('无法访问网络'),
  ERR_BAD_REQUEST: i18n_t('网络请求错误'),
  ERR_BAD_RESPONSE: i18n_t('网络无响应'),
  ENOSPC: i18n_t('磁盘空间已满'),
  ABORT_ERR: i18n_t('操作被中止'),
  ERR_DIR_CLOSED: i18n_t('在fs.Dir以前关闭'),
  ERR_FS_EISDIR: i18n_t('路径是一个目录'),
  ERR_INVALID_ARG_TYPE: i18n_t('错误类型的参数'),
  ERR_INVALID_CHAR: i18n_t('无效字符'),
  UNABLE_TO_VERIFY_LEAF_SIGNATURE: i18n_t('证书检查错误，请检查代理配置'),
  EBUSY: i18n_t('文件/文件夹可能被占有'),
};
export default NodeErrorCodeMap;

export function changeNodeErrorCodeMapLanguage() {
  Object.keys(NodeErrorCodeMap).forEach(key => {
    NodeErrorCodeMap[key] = i18n_t(NodeErrorCodeMap[key]);
  });
}
